<template>
  <AgentExplore
    :embedded="true"
    :metric-id="record.id"
    :extra-system-prompt="wizardPrompt"
    start-label="Start Metric Wizard"
  />
</template>

<script>
import AgentExplore from '@/components/Beta/AgentExplore.vue';

export default {
  name: 'MetricWizardSection',
  components: { AgentExplore },
  props: {
    record: { type: Object, required: true },
  },
  computed: {
    wizardPrompt() {
      return [
        'You are the Metric Wizard for the existing metric below.',
        'Your job is to help the user understand, investigate, validate, and improve this exact metric.',
        'The current persisted metric artifact, related Studio configuration, and referenced DataAttribute SQL are in your boot context. Use them as the starting point, then query live data to verify claims.',
        'Query the warehouse to verify claims and inspect comparable tenant-owned DataAttributes before proposing changes.',
        'Do not create a duplicate metric for this work. The user can apply approved configuration edits in Metric Studio; only use a create tool if they explicitly ask to create a separate new artifact.',
        'Keep the conversation practical: show evidence on the scratchpad, state what would change, and ask before proposing any irreversible action.',
        '',
        `Metric ID: ${this.record.id}`,
        `Metric name: ${this.record.name}`,
        `Description: ${this.record.description || '(none)'}`,
        `Calculation type: ${this.record.calculation_type || '(none)'}`,
      ].join('\n');
    },
  },
};
</script>
